export class NavigationMenu {

    menuName: string;

    IsVisible: boolean;

    menuId: number;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/Navigation/NavigationMenus.ts